import { get } from "lodash";
import { defaultBooleanField } from "helpers/row-logic-helper";

export const shouldShowDeliveryPeriod = data => Boolean(get(data, "covenants.cashManagementDeliveryPeriod"));

export const shouldShowListOfDocs = data => {
  const docs = get(data, "covenants.cashManagementListOfDocs");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowReportingStartDate = data => Boolean(get(data, "covenants.reportStartDate"));

export const shouldShowCashManagementReportingMisc = data => Boolean(get(data, "covenants.cashManagementReportingMisc"));

export const shouldShowWaiverStartDate = data => {
  const shouldShow = defaultBooleanField(data, "covenants.reportingWaiver");
  const docs = get(data, "covenants.reportingWaiverStartDate");

  return Boolean(docs) && (shouldShow);
};
export const shouldShowWaiverStartDateEdit = data => {
  const shouldShow = defaultBooleanField(data, "covenants.reportingWaiver");
  if (shouldShow === "--") {
    return false;
  }

  return shouldShow;
};
export const shouldShowWaiverEndDate = data => {
  const shouldShow = defaultBooleanField(data, "covenants.reportingWaiver");
  const docs = get(data, "covenants.reportingWaiverEndDate");

  return Boolean(docs) && (shouldShow);
};
export const shouldShowWaiverEndDateEdit = data => {
  const shouldShow = defaultBooleanField(data, "covenants.reportingWaiver");
  if (shouldShow === "--") {
    return false;
  }

  return shouldShow;
};
